import { createAction } from '@reduxjs/toolkit';

import { replaceUpperCaseParams } from 'utils/string';
import { getFailurePayload, getRequestPayload, getSuccessPayload } from 'modules/utils';

import * as actionTypes from './actionTypes';

export const fetchEntity = createAction(actionTypes.FETCH_ENTITY, (meta = {}) => {
  const { pathname, search } = window.location;
  const params = replaceUpperCaseParams(search);

  return {
    payload: {
      request: {
        method: 'GET',
        url: `/fo${pathname}${params}`,
      },
    },
    meta,
  };
});

/** @type {(payload: import('./types').Entity, meta?: object) => {payload: import('./types').Entity, meta: object}} */
const getEntitySuccessPayload = getSuccessPayload;

export const fetchEntitySuccess = createAction(actionTypes.FETCH_ENTITY_SUCCESS, getEntitySuccessPayload);

export const fetchEntityFailure = createAction(actionTypes.FETCH_ENTITY_FAILURE, getFailurePayload);

export const readEntity = createAction(actionTypes.READ_ENTITY, getRequestPayload({ method: 'POST' }));

export const readEntitySuccess = createAction(actionTypes.READ_ENTITY_SUCCESS, getSuccessPayload);

export const readEntityFailure = createAction(actionTypes.READ_ENTITY_FAILURE, getFailurePayload);

/** @type {import('@reduxjs/toolkit').ActionCreatorWithOptionalPayload<boolean>} */
export const setDocumentSignatureLoading = createAction(actionTypes.SET_DOCUMENT_SIGNATURE_LOADING);

/**
 * @param {string} signUploadUrl
 * @param {string} signDocumentUrl
 * @param {Blob} image
 * @param {Array<string>} documentIds
 */
export const signDocuments = createAction(
  actionTypes.SIGN_DOCUMENTS,
  (signUploadUrl, signDocumentUrl, image, documentIds) => ({
    payload: { signUploadUrl, signDocumentUrl, image, documentIds },
  })
);

export const signDocumentsFailure = createAction(actionTypes.SIGN_DOCUMENTS_FAILURE, getFailurePayload);

export const openSignatureModal = createAction(actionTypes.OPEN_SIGNATURE_MODAL);
export const closeSignatureModal = createAction(actionTypes.CLOSE_SIGNATURE_MODAL);

export const openSignHereModal = createAction(actionTypes.OPEN_SIGN_HERE_MODAL);
export const closeSignHereModal = createAction(actionTypes.CLOSE_SIGN_HERE_MODAL);

/** @param {Array<string>} documentIds */
export const markSignatureDocumentsDismissed = createAction(
  actionTypes.MARK_SIGNATURE_DOCUMENTS_DISMISSED,
  (documentIds) => ({ payload: documentIds })
);

/**
 * @param {string} url
 * @param {Omit<import('types/Global').CustomerRating, 'date'>} data
 * @param {Object} [meta={}]
 * @returns {import('./types').SendRatingAction}
 */
export const sendRating = createAction(actionTypes.SEND_RATING, (url, data, meta = {}) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      data,
    },
  },
  meta,
}));

export const sendRatingSuccess = createAction(actionTypes.SEND_RATING_SUCCESS, getSuccessPayload);

export const sendRatingFailure = createAction(actionTypes.SEND_RATING_FAILURE, getFailurePayload);
